import { render, staticRenderFns } from "./Testfields.vue?vue&type=template&id=a0c9376c"
import script from "./Testfields.vue?vue&type=script&lang=js"
export * from "./Testfields.vue?vue&type=script&lang=js"
import style0 from "./Testfields.vue?vue&type=style&index=0&id=a0c9376c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports